import Cookies from 'js-cookie';

export const getAnonUser = () => {
  const pianoUid = Cookies.get('pianoUid');
  if (pianoUid) return pianoUid;
  const anonUser = Cookies.get('anonUserOptimizely') || Math.random().toString(36).substr(2, 9);
  Cookies.set('anonUserOptimizely', anonUser);
  return anonUser;
};

export const OPTIMIZELY_EVENT_VALUES = {
  inContentAd0: 1.6,
  inContentAd1: 1.4,
  inContentAd2: 1.6,
  inContentAd3: 1.7,
  inContentAd4: 1.6,
  inContentAd5: 1.5,
  inContentAd6: 1.5,
  inContentAd7: 1.5,
  inContentAd8: 1.5,
  inFeedAd0: 7,
  inFeedAd1: 8,
  inFeedAd2: 7.2,
  inFeedAd3: 6.8,
  inFeedAd4: 6.9,
  inFeedAd5: 0.7,
  stnPlayer: 4.6,
  leaderboardTop: 1.7,
  siderailFlex1: 4.5,
  siderailFlex2: 5.9,
  siderailSticky: 3.7,
  newsletterSubscription: 300,
  signUpValue: 100,
  defaultAdImpression: 1.5,
  finishedArticle: 0,
};

export const OPTIMIZELY_AD_ELEMENTS = {
  Leaderboard0: {
    name: 'leaderboard_ad',
    value: OPTIMIZELY_EVENT_VALUES.leaderboardTop,
  },
  fortunecom_incontent0: {
    name: 'saw_first_ad',
    value: OPTIMIZELY_EVENT_VALUES.inContentAd0,
  },
  fortunecom_infeed0: {
    name: 'saw_first_ad',
    value: OPTIMIZELY_EVENT_VALUES.inFeedAd0,
  },
  fortunecom_incontent1: {
    name: 'saw_second_ad',
    value: OPTIMIZELY_EVENT_VALUES.inContentAd1,
  },
  fortunecom_infeed1: {
    name: 'saw_second_ad',
    value: OPTIMIZELY_EVENT_VALUES.inFeedAd1,
  },
  fortunecom_incontent2: {
    name: 'saw_third_ad',
    value: OPTIMIZELY_EVENT_VALUES.inContentAd2,
  },
  fortunecom_infeed2: {
    name: 'saw_third_ad',
    value: OPTIMIZELY_EVENT_VALUES.inFeedAd2,
  },
  fortunecom_incontent3: {
    name: 'saw_fourth_ad',
    value: OPTIMIZELY_EVENT_VALUES.inContentAd3,
  },
  fortunecom_infeed3: {
    name: 'saw_fourth_ad',
    value: OPTIMIZELY_EVENT_VALUES.inFeedAd3,
  },
  fortunecom_incontent4: {
    name: 'saw_fifth_ad',
    value: OPTIMIZELY_EVENT_VALUES.inContentAd4,
  },
  fortunecom_infeed4: {
    name: 'saw_fifth_ad',
    value: OPTIMIZELY_EVENT_VALUES.inFeedAd4,
  },
  fortunecom_incontent5: {
    name: 'saw_sixth_ad',
    value: OPTIMIZELY_EVENT_VALUES.inContentAd5,
  },
  fortunecom_incontent6: {
    name: 'saw_seventh_ad',
    value: OPTIMIZELY_EVENT_VALUES.inContentAd6,
  },
  fortunecom_incontent7: {
    name: 'saw_eighth_ad',
    value: OPTIMIZELY_EVENT_VALUES.inContentAd7,
  },
  fortunecom_incontent8: {
    name: 'saw_ninth_ad',
    value: OPTIMIZELY_EVENT_VALUES.inContentAd8,
  },
  fortunecom_siderail_flex_1: {
    name: 'saw_static_right_rail',
    value: OPTIMIZELY_EVENT_VALUES.siderailSticky,
  },
  fortunecom_siderail_article_sticky: {
    name: 'saw_sticky_right_rail',
    value: OPTIMIZELY_EVENT_VALUES.siderailFlex1,
  },
  fortunecom_sticky_footer: {
    name: 'saw_footer_ad',
    value: OPTIMIZELY_EVENT_VALUES.leaderboardTop,
  },
};
